/**
 * Logic Necessary for Category groups
 * Author: Imarc 2019
 */

// Dependencies
import '../polyfills/closest';

// DOM

const groupTriggers = [...document.querySelectorAll('.js-groupTrigger')];
const groups = [...document.querySelectorAll('.js-group')];

groupTriggers.forEach(groupTrigger => {
    groupTrigger.addEventListener('click', function addClickEventToTrigger(event) {
        event.preventDefault();

        const currentGroup = groupTrigger.closest('.js-group');
        const groupName = groupTrigger.parentNode.id;

        groups.forEach(group => {
            if (group === currentGroup && !currentGroup.classList.contains('-revealed')) {
                group.classList.add('-revealed');
            } else {
                group.classList.remove('-revealed');
            }
        });
        window.location.hash = `#${groupName}`;
    });
});
